


















import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "../event-bus";

@Component({
  components: {}
})
export default class DiscardModal extends Vue {
  @Prop() readonly value!: boolean;

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeDiscardModal", value);
  }

  private closeEditAccountModal() {
    EventBus.$emit("closeEditAccountModal", false);
    EventBus.$emit("closeEditDeviceModal", false);
  }
}
